/* CUBE STORE - i conti degli importi: forma, tetti, rate, totale, acconto

   Tutto nasce dallo stesso dato - quanto il cliente ha dichiarato di
   pagare, con che metodo, su che totale - e percio' sta nello stesso
   file invece di rileggersi il prezzo per conto proprio.

   Quattro controlli fermano l'ordine, in quest'ordine di precedenza:

     1. l'importo deve essere un numero scritto bene
     2. non deve superare il tetto del suo metodo
     3. le tendine aperte da un metodo vanno scelte
     4. la somma deve fare il prezzo, e l'acconto almeno il 10%

   I primi tre stanno nella stessa nota sotto la casella, e ne compare
   uno solo: se non si capisce il numero, dire anche che supera il
   tetto sarebbe parlare di una cifra che non sappiamo leggere.

   1) UN IMPORTO E' UNA CIFRA, NON UN TESTO

   I campi di Magical sono caselle di testo libere: ci si poteva
   scrivere qualunque cosa e finiva nell'ordine tale e quale. Il
   controllo del totale ne ferma gia' buona parte - una parola vale
   zero e la somma non torna - ma "3479abc" no: la somma tornava e
   nell'ordine arrivava con la coda appresso.

   SI ACCETTA IL FORMATO ITALIANO E BASTA: 1250, 1.250, 1250,50,
   1.250,50. Il punto e' separatore di migliaia, la virgola di
   centesimi.

   "3479.50" VIENE RIFIUTATO, E NON E' UNA DIMENTICANZA. All'italiana
   quel punto sono migliaia e la cifra e' 347.950; all'inglese sono
   centesimi e la cifra e' 3.479,50. Cento volte di differenza, e non
   c'e' modo di sapere quale intendeva. Indovinare al posto suo su una
   dichiarazione di pagamento e' il modo peggiore di sbagliare: si
   chiede di riscriverla, e il messaggio fa vedere come.

   IL ROSSO DELLA FORMA ASPETTA CHE SI ESCA DAL CAMPO. Per scrivere
   1.250 si passa da "1." e da "1.2", che sono forme non valide: un
   avviso a ogni tasto direbbe che sta sbagliando proprio mentre sta
   facendo la cosa giusta. Si guarda quando ha finito, cioe' quando
   lascia la casella - o quando prova a ordinare.

   2) OGNI METODO HA IL SUO TETTO, E IL TETTO LO DICE L'ETICHETTA

   "SeQura (Max 3.000 EUR)" e "Heylight dilazione (max 5.000 EUR)"
   erano scritte e basta: si poteva dichiarare 6.479 su SeQura e
   l'ordine partiva, per poi scoprire in fase di pagamento che quella
   cifra SeQura non la finanzia.

   LA CIFRA SI LEGGE DALL'ETICHETTA, NON DA UNA LISTA NOSTRA. Una
   tabella metodo -> tetto qui dentro sarebbe una seconda verita' da
   tenere allineata a mano a quella che il cliente legge: il giorno che
   SeQura alza il limite si cambia l'etichetta in Magical e ci si
   dimentica di qui. Leggendola dall'etichetta le due non possono
   divergere, perche' sono la stessa.

   SE L'ETICHETTA NON DICE NIENTE, NESSUN TETTO. Bonifico, PayPal e
   carta non ne hanno, ed e' giusto che non ne abbiano: il controllo
   nasce solo dove qualcuno l'ha dichiarato.

   QUESTO ROSSO NON ASPETTA NIENTE, a differenza degli altri. Una cifra
   oltre il massimo e' gia' sbagliata quando la si finisce di scrivere,
   non e' un lavoro a meta'.

   3) LE TENDINE APERTE DA UN METODO VANNO SCELTE

   Spuntando SeQura o Heylight compare anche "Numero rate", che parte
   da "Seleziona" e non e' obbligatoria: lasciandola cosi' l'ordine
   partiva e la risposta NON arrivava affatto - non vuota, proprio
   assente. In negozio si ritrovavano un finanziamento senza sapere in
   quante rate, e toccava richiamare il cliente.

   Vale per qualunque tendina condizionata, non per le tre delle rate
   in particolare: se un domani l'app ne aggiunge un'altra e' gia'
   coperta. Per questo il messaggio e' generico e non parla di rate -
   sotto un'etichetta che dice "Numero rate SeQura" si capisce
   benissimo lo stesso.

   QUESTO ROSSO ASPETTA IL CLIC. Una tendina non ancora scelta e' lo
   stato in cui nasce: rimproverarlo appena si spunta il metodo
   vorrebbe dire sgridare qualcuno per non aver ancora fatto una cosa
   che ha appena scoperto di dover fare.

   4) GLI IMPORTI DEVONO COPRIRE L'INTERA CIFRA

   Vale per tutti e due i moduli. Nella prenotazione si sommano acconto
   E saldo: sono le due meta' dello stesso pagamento, e devono fare il
   prezzo. ANCHE L'ECCEDENZA FERMA: dichiarare piu' del dovuto non e'
   generosita', sono link di pagamento sbagliati da mandare.

   LE DUE RIGHE CHE CONTANO STANNO FERME MENTRE SI SCRIVE, ed e' la
   cosa meno ovvia di questo file. Aggiornandole a ogni tasto, chi
   digitava 4500 vedeva "mancano 7.195", poi 7.154, poi 6.749: il
   numero da raggiungere cambiava sotto gli occhi proprio mentre lo si
   inseguiva, e diventava impossibile capire quale cifra scrivere.

   Percio' finche' il fuoco e' dentro una casella importo, il conto e la
   nota dell'acconto restano com'erano: mostrano quanto mancava PRIMA
   di iniziare a scrivere, che e' esattamente il numero che serve.
   Riprendono a contare appena si esce dalla casella, o quando si tocca
   qualcos'altro - una spunta, la quantita'.

   Congelare non allenta nessun controllo: quelli che fermano l'ordine
   girano lo stesso al momento del clic, dove sono chiamati
   direttamente. Qui si ferma solo cio' che si VEDE.

   IL SALDO PUO' RESTARE VUOTO, MA SOLO SE L'ACCONTO COPRE TUTTO, e
   non e' una svista: e' una scelta di Marco dell'8 agosto 2026. Chi
   paga l'intero prezzo subito non ha nessun saldo da dichiarare, e
   obbligarlo a spuntare una modalita' per zero euro gli farebbe
   dichiarare una cosa che non esiste. Il caso pericoloso - acconto
   parziale e saldo vuoto - lo ferma gia' questo conto. Chi in futuro
   vedra' mancare un controllo "il saldo deve avere una modalita'"
   sappia che manca apposta.

   IL TOTALE CAMBIA ANCHE CON LA QUANTITA', E LI' NESSUNO AVVISA.
   Premendo piu' o meno il tema riscrive il valore della casella senza
   emettere ne' input ne' change: misurato, zero eventi. Senza il
   rattoppo nel gestore dei clic qui sotto, i conti restavano fermi al
   totale di prima e il cliente leggeva "acconto minimo 719,90" su un
   ordine da 14.398. Chi tocca quella parte non la tolga pensando che
   sia ridondante.

   5) LA DIFFERENZA SI CALCOLA DA SOLA (tutti e due i moduli)

     resta UN solo campo importo vuoto -> lo compila con la differenza
     ne restano DUE o piu'             -> mette la differenza come
                                          suggerimento, senza scegliere

   Con due campi vuoti la differenza puo' andare tutta nell'uno o tutta
   nell'altro, e sceglierlo noi vorrebbe dire mettere in bocca al
   cliente una decisione che e' sua.

   Questo continua a girare anche mentre si scrive, e non contraddice
   il congelamento qui sopra: tocca le caselle che il cliente NON sta
   compilando, non il numero che sta leggendo.

   NELLA PRENOTAZIONE SI COMPILA IL SALDO, MAI L'ACCONTO.

   L'acconto e' il primo campo che si accende, e riempirlo con la
   differenza vorrebbe dire proporre come acconto l'intero prezzo della
   bici: il contrario di quello che l'acconto e'. Percio' finche'
   l'acconto e' vuoto, nel saldo non compare niente - nemmeno un
   suggerimento: sarebbe una cifra calcolata su un acconto che non
   esiste ancora.

   Il saldo invece non e' una scelta, e' un resto: prezzo meno acconto,
   non c'e' nient'altro che possa essere. Farlo ricopiare a mano era
   solo un'occasione di sbagliare - e su una bici da 8.499 l'errore non
   e' di quelli che si notano. Appena l'acconto ha una cifra, il saldo
   si riempie da se'.

   CHI SCRIVE A MANO NEL SALDO SE LO TIENE. Da quel momento quella
   casella non viene piu' toccata, nemmeno se l'acconto cambia: il
   cliente ha detto una cosa e non gliela si riscrive sotto gli occhi.
   Se i conti smettono di tornare glielo dice la riga del totale.

   6) L'ACCONTO NON PUO' SCENDERE SOTTO IL 10%

   Si guarda la SOMMA degli importi dell'acconto, non ogni singolo
   campo: chi versa il 5% per bonifico e il 5% con carta ha comunque
   versato il 10% dovuto. (Oggi cube-campi.js lascia spuntare un solo
   metodo di acconto, quindi il caso non si presenta: la somma resta
   perche' e' la regola commerciale giusta, non perche' serva adesso.)

   IMPEDIRE LA DIGITAZIONE SAREBBE PEGGIO
   Per scrivere 720 si passa da 7 e da 72, che sono sotto il minimo:
   un campo che rifiuta i tasti impedirebbe di scrivere il numero
   giusto. Si lascia scrivere e si ferma l'ordine.

   TUTTI I BLOCCHI VIVONO SULLO STESSO ASCOLTATORE, IN FASE DI CATTURA,
   che gira prima di quelli dell'app e del tema: fermando li' la
   propagazione, ne' Magical ne' <add-to-cart-component> ricevono il
   click, e niente parte a meta'. Da qui non passa nemmeno il submit,
   quindi cube-checkout.js non entra in gioco.

   ==========================================================
   FERMARE NON BASTA: BISOGNA FARSI VEDERE
   ==========================================================

   Il pulsante sta in un piede fisso, l'avviso sta nel corpo che
   scorre. Chi preme PRENOTA con la finestra scorsa in alto non vede
   niente cambiare, ci riprova, e conclude che il sito e' rotto.

   Percio' a ogni blocco si porta l'avviso in vista e si mette il fuoco
   sul campo da correggere. L'ORDINE DELLE DUE COSE NON E' INDIFFERENTE,
   ed e' il punto in cui questa parte si era gia' rotta una volta:
   focus() di suo porta in vista l'elemento a cui lo si da'. Facendolo
   DOPO lo scorrimento, disfaceva il lavoro appena fatto e la finestra
   restava ferma sul campo invece che sull'avviso - che magari e' in
   fondo, dove il cliente non stava guardando. Misurato: avviso a
   cinque pixel fuori dal bordo, fuoco su un campo tutt'altrove.

   Adesso il fuoco arriva prima e con preventScroll, cosi' la tastiera
   e' gia' nel posto giusto ma la vista non si muove; poi si scorre
   all'avviso, che resta l'ultima parola. Chi invertisse di nuovo le
   due righe rimetterebbe il guasto senza che nessun errore lo dica.

   L'aria intorno all'avviso quando ci si scorre la mette
   cube-modulo.css con scroll-margin: senza, il browser lo considera
   "in vista" anche quando ne spunta una riga contro il bordo.

   SI CONTA SOLO A FINESTRA APERTA
   Fuori non c'e' niente da mostrare e niente da fermare: il pulsante
   del tema, quando i due tasti sono accesi, non e' nemmeno in pagina.

   I CONTENITORI NON SONO CAMPI
   Fra gli .ma-custom-field[data-conditions] ce ne sono due che
   racchiudono gli altri - gli elenchi acconto e saldo - e hanno
   data-conditions vuoto. cubeCondizioneCampo risponde null per loro, ed
   e' quello che li tiene fuori da ogni giro: senza quel filtro il
   primo input o la prima tendina che si trova dentro verrebbe
   scambiata per il campo del contenitore.

   7) IL BUONO OMAGGIO (tutti e due i moduli)

   Spetta a chi paga almeno il 90% con bonifico, sommando acconto e
   saldo. Sotto la soglia il modulo non c'e': chiedere una cosa a cui il
   cliente non ha ancora diritto e' peggio che non chiederla.

   La stessa soglia si affaccia su window perche' la usa anche la "i"
   di spiegazione accanto al bonifico del saldo (cube-info.js).

   Il valore non lo scrivono le caselle ma un campo nascosto che
   governiamo noi, e che parte da "Da concordare": cosi' la risposta c'e'
   sempre. Nessuna preselezione, ed e' voluto - sono quattrocento euro.
   Quando il buono non spetta il campo viene DISATTIVATO, e un campo
   disattivato non viene inviato.

   PERCHE' SI GUARDA LA CASELLA E NON SE IL CAMPO SI VEDE
   Un campo dentro una finestra chiusa non si vede mai, e a finestra
   chiusa la somma sarebbe zero. Si guarda se il metodo e' spuntato, che
   e' vero indipendentemente da cosa e' aperto: lo chiede a
   cube-campi.js, che quel legame lo conosce gia'.

   8) COSE COMUNI

   La distinzione fra cio' che scrive il cliente e cio' che scriviamo
   noi si regge su isTrusted, che il browser mette a true solo sugli
   eventi nati da una persona vera. E' anche cio' che impedisce a questo
   file di rincorrere le proprie scritture.

   Il prezzo si legge dalla pagina perche' non c'e' un dato migliore a
   portata: cambia con la taglia, e il tema lo ridisegna.

   Il formato italiano si scrive a mano, non con toLocaleString: in
   questo negozio aveva gia' dato numeri senza separatore di migliaia. */
(function () {
  var IMPORTO = /^\s*importo/i;
  var BONIFICO = /bonific/i;
  var ACCONTO = /acconto/i;
  var SALDO = /saldo/i;
  var TETTO = /(?:max|massimo)[^\d]{0,8}([\d.]+(?:,\d+)?)/i;

  /* 1250 | 1.250 | 1250,50 | 1.250,50 - e nient'altro */
  var FORMATO = /^(?:\d{1,3}(?:\.\d{3})+|\d+)(?:,\d{1,2})?$/;

  var COME_SCRIVERE = 'Scrivi solo la cifra, con la virgola per i centesimi: per esempio 1.250,00.';
  var DA_SCEGLIERE = 'Scegli un\'opzione per continuare.';

  var QUOTA_ACCONTO = 0.1;
  var SOGLIA_BUONO = 0.9;

  /* la legge anche cube-info.js per scrivere la spiegazione */
  window.cubeSogliaBuono = SOGLIA_BUONO;

  var NON_SCELTO = 'Da concordare';
  var SCELTE = [
    { valore: 'Scontato da questo ordine', etichetta: 'Scontalo subito da questo ordine' },
    { valore: 'Buono per un prossimo acquisto', etichetta: 'Tienilo come buono per un prossimo acquisto' }
  ];

  var riepilogo = null;
  var avviso = null;
  var buono = null;
  var buonoTitolo = null;
  var buonoCampo = null;

  /* il primo campo da correggere, per portarci il fuoco */
  var primoRotto = null;

  /* qualcuno ha gia' provato a ordinare con i conti che non tornano:
     da quel momento il grigio diventa rosso */
  var tentatoAcconto = false;
  var tentatoTotale = false;
  var tentatoCampi = false;

  /* ---------- numeri ---------- */

  function aNumero(testo) {
    var s = String(testo == null ? '' : testo).replace(/[^\d,]/g, '').replace(',', '.');
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }

  function arrotonda(n) {
    return Math.round(n * 100) / 100;
  }

  function fmt(n) {
    var negativo = n < 0;
    n = Math.abs(n);

    var intero = Math.floor(n);
    var decimali = Math.round((n - intero) * 100);
    if (decimali === 100) {
      intero++;
      decimali = 0;
    }

    var s = String(intero).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (negativo ? '-' : '') + s + ',' + (decimali < 10 ? '0' + decimali : decimali);
  }

  function euro(n) {
    return '€' + fmt(n);
  }

  /* spazi e simbolo di valuta non sono un errore di chi scrive */
  function ripulisci(v) {
    return String(v == null ? '' : v).replace(/[\s€]/g, '');
  }

  /* il cliente ha le dita dentro una casella importo: vedi
     "LE DUE RIGHE CHE CONTANO STANNO FERME MENTRE SI SCRIVE" */
  function staScrivendo() {
    var a = document.activeElement;
    if (!a || !a.closest || !a.closest('.ma-custom-field')) return false;
    return a.type === 'text' || a.type === 'number';
  }

  /* ---------- il totale dell'ordine ---------- */

  function prezzoUnitario() {
    var cont = document.querySelector('product-price [ref="priceContainer"]');
    if (!cont) return 0;

    var blocco = null;
    [].forEach.call(cont.children, function (d) {
      if (!blocco && !d.classList.contains('price__hidden')) blocco = d;
    });
    if (!blocco) return 0;

    var el = blocco.querySelector('.price');
    return el ? aNumero(el.textContent) : 0;
  }

  function quantita() {
    var q = document.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function totale() {
    return arrotonda(prezzoUnitario() * quantita());
  }

  /* ---------- campi per condizione ---------- */

  function importoDi(campo) {
    return campo.querySelector('input[type="text"], input[type="number"]');
  }

  function campiSpuntati(prova, radice) {
    var out = [];
    if (typeof window.cubeCondizioneCampo !== 'function') return out;
    if (typeof window.cubeCasellaDiComando !== 'function') return out;

    (radice || document).querySelectorAll('.ma-custom-field[data-conditions]').forEach(function (campo) {
      var cond = window.cubeCondizioneCampo(campo);
      if (!cond || !prova(cond)) return;

      var comando = window.cubeCasellaDiComando(campo);
      if (!comando || !comando.checked) return;

      /* solo le caselle di testo: il "Numero rate" e' una tendina e non
         e' una cifra da sommare */
      var inp = importoDi(campo);
      if (inp) out.push(inp);
    });
    return out;
  }

  function tutti() {
    return true;
  }

  function somma(caselle) {
    var t = 0;
    caselle.forEach(function (c) {
      t += aNumero(c.value);
    });
    return arrotonda(t);
  }

  /* ---------- quale modulo e' in uso ---------- */

  /* null a finestra chiusa: vedi "SI CONTA SOLO A FINESTRA APERTA" */
  function gruppoInUso() {
    var m = document.getElementById('cube-modale');
    if (!m || m.hidden) return null;
    var azione = m.dataset.azione;
    return azione ? document.querySelector('.cube-gruppo--' + azione) : null;
  }

  /* ---------- forma, tetto e tendine, campo per campo ---------- */

  function rigaDi(comando) {
    return comando && comando.closest ? comando.closest('.ma-fieldset-option') : null;
  }

  function tettoDi(comando, campo) {
    var riga = rigaDi(comando);
    var etichetta = campo.querySelector('label');

    var testi = [riga ? riga.textContent : '', etichetta ? etichetta.textContent : ''];
    for (var i = 0; i < testi.length; i++) {
      var m = TETTO.exec(testi[i] || '');
      if (m) return aNumero(m[1]);
    }
    return 0;
  }

  /* "SeQura (Max 3.000 EUR)" -> "SeQura": nel messaggio il tetto lo
     diciamo noi, ripeterlo fra parentesi sarebbe solo rumore */
  function nomeMetodo(comando) {
    var riga = rigaDi(comando);
    var t = riga ? riga.textContent : '';
    return t.replace(/\s+/g, ' ').replace(/\s*\([^)]*\)\s*$/, '').trim();
  }

  /* true se l'importo puo' andare nell'ordine cosi' com'e' */
  function importoValido(campo, comando, inp) {
    var scritto = ripulisci(inp.value);
    if (!scritto) return true;
    if (!FORMATO.test(scritto)) return false;

    var tetto = tettoDi(comando, campo);
    return !(tetto > 0 && aNumero(scritto) > tetto);
  }

  /* il messaggio da mostrare su un importo, o '' se non serve */
  function problemaImporto(campo, comando, inp) {
    var scritto = ripulisci(inp.value);

    /* vuoto non e' sbagliato: se ne occupa il conto in fondo */
    if (!scritto) return '';

    if (!FORMATO.test(scritto)) {
      /* solo dopo che ha finito di scrivere: vedi il commento in testa */
      return inp.dataset.cubeVisto === '1' || tentatoCampi ? COME_SCRIVERE : '';
    }

    var tetto = tettoDi(comando, campo);
    var valore = aNumero(scritto);
    if (tetto > 0 && valore > tetto) {
      return nomeMetodo(comando) + ' accetta al massimo ' + euro(tetto) +
        ' — hai indicato ' + euro(valore) + '.';
    }

    return '';
  }

  function controllaCampi() {
    var g = gruppoInUso();
    primoRotto = null;
    if (!g) return true;
    if (typeof window.cubeCondizioneCampo !== 'function') return true;

    var ok = true;

    g.querySelectorAll('.ma-custom-field[data-conditions]').forEach(function (campo) {
      /* i contenitori rispondono null e restano fuori: vedi in testa */
      if (!window.cubeCondizioneCampo(campo)) return;

      var inp = importoDi(campo);
      var tendina = inp ? null : campo.querySelector('select');
      if (!inp && !tendina) return;

      var comando = window.cubeCasellaDiComando(campo);
      var nota = campo.querySelector('.cube-nota');
      var testo = '';

      if (!comando || !comando.checked) {
        if (nota && !nota.hidden) nota.hidden = true;
        return;
      }

      if (tendina) {
        if (!tendina.value) {
          ok = false;
          if (!primoRotto) primoRotto = tendina;
          if (tentatoCampi) testo = DA_SCEGLIERE;
        }
      } else {
        if (!importoValido(campo, comando, inp)) {
          ok = false;
          if (!primoRotto) primoRotto = inp;
        }
        testo = problemaImporto(campo, comando, inp);
      }

      if (!testo) {
        if (nota && !nota.hidden) nota.hidden = true;
        return;
      }

      if (!nota) {
        nota = document.createElement('p');
        nota.className = 'cube-nota';
        campo.appendChild(nota);
      }
      if (nota.textContent !== testo) nota.textContent = testo;
      if (nota.hidden) nota.hidden = false;
    });

    return ok;
  }

  /* ---------- il conto del pagamento su misura ---------- */

  function campi() {
    var g = document.querySelector('.cube-gruppo--su-misura');
    if (!g) return [];

    var out = [];
    g.querySelectorAll('.ma-custom-field').forEach(function (f) {
      if (f.offsetParent === null) return;

      var etichetta = f.querySelector('label, legend');
      if (!etichetta || !IMPORTO.test(etichetta.textContent || '')) return;

      var inp = importoDi(f);
      if (inp) out.push(inp);
    });
    return out;
  }

  function scrivi(inp, testo) {
    if (inp.value === testo) return;
    inp.value = testo;
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* La differenza finisce nell'unica casella rimasta vuota; se ne
     restano due o piu' diventa solo un suggerimento. Le due funzioni
     qui sotto fanno la stessa cosa su moduli diversi, e la parte
     comune sta in riparti(). */
  function riparti(caselle, resto) {
    var scrittiAMano = [];
    var liberi = [];
    caselle.forEach(function (c) {
      if (c.dataset.cubeMano === '1') scrittiAMano.push(c);
      else liberi.push(c);
    });

    var rimasto = arrotonda(resto - somma(scrittiAMano));

    if (liberi.length === 1 && rimasto > 0) {
      liberi[0].dataset.cubeAuto = '1';
      scrivi(liberi[0], fmt(rimasto));
    } else {
      liberi.forEach(function (c) {
        if (c.dataset.cubeAuto === '1') {
          delete c.dataset.cubeAuto;
          scrivi(c, '');
        }
      });
    }

    var suggerimento = rimasto > 0 ? fmt(rimasto) : '';
    liberi.forEach(function (c) {
      if (c.placeholder !== suggerimento) c.placeholder = suggerimento;
    });
  }

  function ricalcola() {
    var lista = campi();
    if (!lista.length) return;

    riparti(lista, totale());
  }

  /* ---------- il saldo della prenotazione ---------- */

  function campiSaldo() {
    var g = document.querySelector('.cube-gruppo--prenota');
    if (!g) return [];

    return campiSpuntati(function (cond) {
      return SALDO.test(cond.name);
    }, g);
  }

  /* Vedi "NELLA PRENOTAZIONE SI COMPILA IL SALDO, MAI L'ACCONTO".
     Finche' l'acconto e' vuoto qui non si scrive niente: una
     differenza calcolata su un acconto che non esiste sarebbe l'intero
     prezzo della bici, cioe' un numero sbagliato scritto con
     sicurezza. */
  function ricalcolaSaldo() {
    var lista = campiSaldo();
    if (!lista.length) return;

    var tot = totale();
    var versato = somma(campiAcconto());

    if (tot <= 0 || versato <= 0) {
      lista.forEach(function (c) {
        if (c.dataset.cubeAuto === '1') {
          delete c.dataset.cubeAuto;
          scrivi(c, '');
        }
        if (c.placeholder) c.placeholder = '';
      });
      return;
    }

    riparti(lista, arrotonda(tot - versato));
  }

  /* ---------- il conto, per tutti e due i moduli ---------- */

  function contoDelModulo() {
    var g = gruppoInUso();
    var lista = g ? campiSpuntati(tutti, g) : [];
    var tot = totale();

    if (!lista.length || tot <= 0) {
      if (riepilogo && riepilogo.isConnected) riepilogo.remove();
      return true;
    }

    var inseriti = somma(lista);
    var resto = arrotonda(tot - inseriti);
    var basta = Math.abs(resto) < 0.005;

    /* chi ha corretto non si porta dietro il rosso */
    if (basta) tentatoTotale = false;

    if (!riepilogo || !riepilogo.isConnected) {
      riepilogo = document.createElement('p');
      riepilogo.className = 'cube-somma';
    }
    if (riepilogo.parentElement !== g) g.appendChild(riepilogo);

    var testo;
    var stato;

    if (basta) {
      testo = 'Totale ordine ' + euro(tot) + ' — gli importi coprono l\'intera cifra';
      stato = 'ok';
    } else if (resto > 0) {
      testo = tentatoTotale
        ? 'Per continuare gli importi devono coprire ' + euro(tot) + ': mancano ' + euro(resto) + '.'
        : 'Totale ordine ' + euro(tot) + ' — inseriti ' + euro(inseriti) + ', mancano ' + euro(resto);
      stato = 'manca';
    } else {
      testo = 'Totale ordine ' + euro(tot) + ' — inseriti ' + euro(inseriti) + ', eccedenza ' + euro(-resto);
      stato = 'troppo';
    }

    if (riepilogo.textContent !== testo) riepilogo.textContent = testo;
    if (riepilogo.dataset.stato !== stato) riepilogo.dataset.stato = stato;

    var severo = !basta && tentatoTotale ? '1' : '';
    if ((riepilogo.dataset.tentato || '') !== severo) riepilogo.dataset.tentato = severo;

    return basta;
  }

  /* il primo importo da sistemare: quello vuoto, se c'e' */
  function primoImporto() {
    var g = gruppoInUso();
    var lista = g ? campiSpuntati(tutti, g) : [];
    for (var i = 0; i < lista.length; i++) {
      if (!aNumero(lista[i].value)) return lista[i];
    }
    return lista[0] || null;
  }

  /* ---------- l'acconto minimo ---------- */

  function campiAcconto() {
    return campiSpuntati(function (cond) {
      return ACCONTO.test(cond.name);
    });
  }

  function controllaAcconto() {
    var attivi = campiAcconto();
    var tot = totale();
    var minimo = arrotonda(tot * QUOTA_ACCONTO);

    if (!attivi.length || minimo <= 0) {
      if (avviso && avviso.isConnected) avviso.remove();
      return true;
    }

    var suggerimento = 'minimo ' + fmt(minimo);
    attivi.forEach(function (c) {
      if (c.placeholder !== suggerimento) c.placeholder = suggerimento;
    });

    var versato = somma(attivi);
    var basta = versato >= minimo;

    if (basta) tentatoAcconto = false;

    var rimprovero = !basta && (versato > 0 || tentatoAcconto);

    var elenco = attivi[0].closest('fieldset');
    if (elenco) {
      if (!avviso || !avviso.isConnected) {
        avviso = document.createElement('p');
        avviso.className = 'cube-minimo';
      }
      if (avviso.parentElement !== elenco) elenco.appendChild(avviso);

      var testo = rimprovero
        ? 'L\'acconto deve essere almeno ' + euro(minimo) + ', il 10% di ' + euro(tot) +
          '. Finora hai indicato ' + euro(versato) + '.'
        : 'Acconto minimo ' + euro(minimo) + ', il 10% di ' + euro(tot) + '.';
      var stato = rimprovero ? 'manca' : 'ok';

      if (avviso.textContent !== testo) avviso.textContent = testo;
      if (avviso.dataset.stato !== stato) avviso.dataset.stato = stato;
    }

    return basta;
  }

  /* ---------- il buono bonifico ---------- */

  function valoreBuono() {
    var el = document.querySelector('.cube-voucher__amount');
    return el ? aNumero(el.textContent) : 0;
  }

  function costruisciBuono() {
    if (buono) return buono;

    buono = document.createElement('div');
    buono.className = 'cube-buono';
    buono.hidden = true;

    buonoTitolo = document.createElement('p');
    buonoTitolo.className = 'cube-buono__titolo';

    var testo = document.createElement('p');
    testo.className = 'cube-buono__testo';
    testo.textContent = 'Paghi almeno il ' + Math.round(SOGLIA_BUONO * 100) +
      '% con bonifico, quindi il buono ti spetta. Come preferisci usarlo?';

    buonoCampo = document.createElement('input');
    buonoCampo.type = 'hidden';
    buonoCampo.name = 'properties[Buono omaggio bonifico]';
    buonoCampo.value = NON_SCELTO;

    buono.appendChild(buonoTitolo);
    buono.appendChild(testo);

    SCELTE.forEach(function (s) {
      var riga = document.createElement('label');
      riga.className = 'cube-buono__scelta';

      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'cube-buono';
      radio.value = s.valore;
      radio.addEventListener('change', function () {
        buonoCampo.value = s.valore;
      });

      var etichetta = document.createElement('span');
      etichetta.textContent = s.etichetta;

      riga.appendChild(radio);
      riga.appendChild(etichetta);
      buono.appendChild(riga);
    });

    buono.appendChild(buonoCampo);
    return buono;
  }

  function aggiornaBuono() {
    var corpo = document.querySelector('.cube-modale__corpo');
    if (!corpo) return;

    var m = costruisciBuono();
    if (m.parentElement !== corpo) corpo.appendChild(m);

    var valore = valoreBuono();
    var tot = totale();
    var versato = somma(campiSpuntati(function (cond) {
      return BONIFICO.test(cond.value);
    }));

    var spetta = valore > 0 && tot > 0 && versato >= arrotonda(tot * SOGLIA_BUONO);

    if (m.hidden === spetta) m.hidden = !spetta;
    if (buonoCampo.disabled === spetta) buonoCampo.disabled = !spetta;

    if (!spetta) return;

    var t = 'Buono omaggio ' + euro(valore);
    if (buonoTitolo.textContent !== t) buonoTitolo.textContent = t;
  }

  /* ---------- ascolto ---------- */

  /* forzaConti: rifai anche le due righe che contano. Serve a chi sa
     che il cliente ha finito di scrivere - uscita dal campo, spunta,
     quantita' - mentre la digitazione le lascia ferme. */
  function aggiorna(forzaConti) {
    ricalcola();
    ricalcolaSaldo();
    controllaCampi();

    if (forzaConti || !staScrivendo()) {
      contoDelModulo();
      controllaAcconto();
    }

    aggiornaBuono();
  }

  /* Il contrassegno "scritto a mano" vale in tutti e due i moduli:
     e' cio' che impedisce di riscrivere sotto le dita del cliente una
     casella che ha compilato lui. */
  function suoDeiModuli(el) {
    return !!(el && el.closest && el.closest('.cube-gruppo'));
  }

  document.addEventListener('input', function (e) {
    if (!e.isTrusted) return;

    var t = e.target;

    if (suoDeiModuli(t) && t.matches('input[type="text"], input[type="number"]')) {
      if (t.value.trim()) {
        t.dataset.cubeMano = '1';
        delete t.dataset.cubeAuto;
      } else {
        delete t.dataset.cubeMano;
        delete t.dataset.cubeAuto;
      }
    }

    /* niente forzatura: qui si sta scrivendo */
    aggiorna();
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.isTrusted) return;

    aggiorna(true);

    /* taglia cambiata: il tema riscrive il prezzo dopo, e il totale
       giusto si legge solo a ridisegno avvenuto */
    setTimeout(function () {
      aggiorna(true);
    }, 400);
  }, true);

  /* uscendo dalla casella ha finito di scrivere: da qui in poi la sua
     forma si puo' giudicare, e i conti tornano a muoversi. In cattura
     perche' blur non risale. */
  document.addEventListener('blur', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (!t.matches('.ma-custom-field input[type="text"], .ma-custom-field input[type="number"]')) return;

    t.dataset.cubeVisto = '1';
    aggiorna(true);
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    /* all'apertura della finestra i campi diventano visibili per la
       prima volta, e nessun evento lo racconta */
    if (e.target.closest('.cube-azioni__tasto')) {
      setTimeout(function () {
        aggiorna(true);
      }, 60);
      return;
    }

    /* nemmeno la quantita' lo racconta: premendo piu' o meno il tema
       riscrive il valore della casella senza emettere ne' input ne'
       change. Si guarda il clic e si ricontano i totali dopo, quando
       il nuovo valore c'e'. Il secondo giro copre il ridisegno del
       blocco acquisto. */
    if (e.target.closest('quantity-selector-component')) {
      setTimeout(function () {
        aggiorna(true);
      }, 0);
      setTimeout(function () {
        aggiorna(true);
      }, 300);
      return;
    }

    if (!e.target.closest('.add-to-cart-button')) return;

    var campiOk = controllaCampi();
    var accontoOk = controllaAcconto();
    var totaleOk = contoDelModulo();
    if (campiOk && accontoOk && totaleOk) return;

    /* ora il rosso ci sta: il cliente ha provato a ordinare */
    if (!campiOk) {
      tentatoCampi = true;
      controllaCampi();
    }
    if (!accontoOk) {
      tentatoAcconto = true;
      controllaAcconto();
    }
    if (!totaleOk) {
      tentatoTotale = true;
      contoDelModulo();
    }

    /* si ferma qui: in cattura, prima di Magical e di
       <add-to-cart-component>, cosi' nessuno dei due parte a meta' */
    e.preventDefault();
    e.stopPropagation();

    /* si sceglie il problema piu' preciso: prima il campo sbagliato,
       poi l'acconto, e solo alla fine il conto generale */
    var nota;
    var primo;

    if (!campiOk) {
      primo = primoRotto;
      nota = primo ? primo.parentElement.querySelector('.cube-nota') : null;
    } else if (!accontoOk) {
      nota = avviso;
      primo = campiAcconto()[0];
    } else {
      nota = riepilogo;
      primo = primoImporto();
    }

    /* PRIMA il fuoco, e senza muovere la vista; POI lo scorrimento.
       Invertirli rimette il guasto: vedi "FERMARE NON BASTA" in testa. */
    if (primo && primo.focus) primo.focus({ preventScroll: true });
    if (nota && nota.scrollIntoView) nota.scrollIntoView({ block: 'center' });
  }, true);
})();
